import { changePassword, completeSignUp, resetPassword } from './../model/user.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { addUser, verifyLogin } from '../model/user.model';
import { BaseUrlService } from './base-url.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor( private http: HttpClient, private base:BaseUrlService ) { }

  private userUrl = this.base._userUrl;

  // GATEWAY API

  verifyLogin(payload: verifyLogin):Observable<verifyLogin>{
    return this.http.post<any>(this.userUrl + 
      `/verify/login`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }

  
  initiateResetPassword(email: string, resetLink: string ):Observable<verifyLogin>{
    return this.http.post<any>(this.userUrl + 
      `/verify/password/reset?email=${email}&reset_link=${resetLink}`, null)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }

  
  resetPasswordComplete(payload: resetPassword):Observable<resetPassword>{
    return this.http.post<any>(this.userUrl + 
      `/verify/password/reset/complete`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }


  // USER API



  addUser(payload:addUser):Observable<addUser>{
    return this.http.post<any>(this.userUrl + 
      `/user/add`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }
  
  updateUser(payload:addUser):Observable<addUser>{
    return this.http.post<any>(this.userUrl + 
      `/user/update`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }

  
  changePassword(payload: changePassword):Observable<changePassword>{
    return this.http.post<any>(this.userUrl + 
      `/user/changepassword`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }

  getUserList(appcode: string, clientid: string, page: number, size: number): Observable<any>{
    return this.http.get<any>(this.userUrl +
      `/user/list?appcode=${appcode}&clientid=${clientid}&page=${page}&size=${size}`)
    .pipe(
      catchError(err => this.errorHandler(err))
    )
  }

  retrievePhoto(accountid: number): Observable<any>{
    return this.http.get<any>(this.userUrl +
      `/user/preview/photo?accountid=${accountid}`,{ responseType: 'blob' as 'json' })
    .pipe(
      catchError(err => this.errorHandler(err))
    )
  }

  changeStatus(id:number,status:number):Observable<addUser>{
    return this.http.put<any>(this.userUrl + 
      `/user/activate-diactivate/${id}?status=${status}`,null)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }
 

  getRoleList(appcode: string): Observable<any>{
    return this.http.get<any>(this.userUrl +
      `/user/role/list?appcode=${appcode}`)
    .pipe(
      catchError(err => this.errorHandler(err))
    )
  }

  userActivateDeactivate(id:number, status:number, payload):Observable<any>{
    return this.http.put<any>(this.userUrl + 
      `/user/activate-diactivate/${id}?status=${status}`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }

  uploadPhoto(accountid:number, file):Observable<any>{
    return this.http.post<any>(this.userUrl + 
      `/user/upload/photograph?accountid=${accountid}`, file)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }

  //poi

  activateSignUp(payload: completeSignUp):Observable<completeSignUp>{
    return this.http.post<any>(this.userUrl + 
      `/verify/account/activation`, payload)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }

  deleteUser(id: number,){
    return this.http.delete<any>(this.userUrl + `/user/delete/${id}`)
    .pipe(
      catchError( err => this.errorHandler(err))
    )
  }



  errorHandler(error:HttpErrorResponse){
    return throwError(error.message || "Server Error") 
  }
}
